// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3445":"26e3fa22","9224":"b3374e2b"}[chunkId] + ".chunk.css";
};